import { authClient, API } from '../index'

// Get constants
export const getConstants = () => {
  return authClient().get(`${API}/constant`)
}

// Update constants
export const updateConstants = (constants) => {
  return authClient().put(`${API}/constant`, constants)
}

